<template>
  <v-card>
    <v-card-title>
      <v-btn
        color="success"
        @click="openRecipientForm('new')"
        small
        outline
        slot="end"
      >
        <v-icon class="pr-1">receipt_long</v-icon>adicionar recebedor
      </v-btn>
    </v-card-title>

    <v-data-table
      :headers="recipientHeaders"
      :items="recipients"
      :pagination.sync="pag"
      no-data-text="Nenhum recebedor encontrado"
    >
      <template v-slot:items="props">
        <td>{{ props.item.bank_account.legal_name }}</td>
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.bank_account.document_number }}</td>
        <td>{{ props.item.bank_account.bank_code }}</td>
        <td>{{ props.item.bank_account.agencia }}</td>
        <td>{{ props.item.bank_account.agencia_dv }}</td>
        <td>{{ props.item.bank_account.conta }}</td>
        <td>{{ props.item.bank_account.conta_dv }}</td>
        <td class="text-xs-right">
          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="openRecipientForm('edit', props.item.id)"
            :disabled="loading"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:no-data v-if="loading">
        <div class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="#7C3DFF"
          ></v-progress-circular>
        </div>
      </template>
    </v-data-table>

    <recipient-form
      :key="recipientFormKey"
      :type="recipientFormData.type"
      :partnerId="recipientFormData.partnerId"
      :recipient="recipientFormData.recipient"
      :accounts="accounts"
      @updateList="updateList"
    />
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import RecipientForm from "./RecipientForm.vue";

export default {
  components: { RecipientForm },

  props: {
    partnerId: {
      type: String,
      default: null,
    },
    accounts: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    loading: false,
    recipientFormKey: 0,
    recipientFormData: {
      type: null,
      partnerId: null,
    },
    recipientHeaders: [
      { text: "Nome", align: "left", sortable: false, value: "name" },
      { text: "ID do Recebedor", value: "id" },
      { text: "Número do Documento", value: "document_number" },
      { text: "Código do Banco", value: "bank_code" },
      { text: "Agência", value: "agencia" },
      { text: "Dígito da Agência", value: "agencia_dv" },
      { text: "Conta", value: "conta" },
      { text: "Dígito da Conta", value: "conta_dv" },
      { text: "Ações", value: "actions", sortable: false },
    ],
    pag: {
      rowsPerPage: 10,
    },
    recipients: [],
  }),

  computed: {
    ...mapGetters("configuration", ["filteredRecipients"]),

    partner() {
      return this.partnerId ? this.partnerById(this.partnerId) : {};
    },
  },

  methods: {
    ...mapMutations("configuration", ["setRecipientDialog"]),
    ...mapActions("configuration", ["getRecipientsByAccount"]),

    openRecipientForm(type, recipientId) {
      this.recipientFormData = {
        type,
        partnerId: this.partnerId,
        recipient:
          this.recipients.find((recipient) => recipient.id === recipientId) ??
          null,
      };
      this.setRecipientDialog(true);
      this.recipientFormKey += 1;
    },

    updateList() {
      this.recipients = this.filteredRecipients(this.accounts);
    },
  },

  mounted() {
    this.loading = true;
    this.recipients = this.filteredRecipients(this.accounts);
    this.loading = false;
  },
};
</script>
